// extracted by mini-css-extract-plugin
module.exports = {"section":"PricingHero_section__pRQ6r","description":"PricingHero_description__wflzY","subtitle":"PricingHero_subtitle__qOnL0","link":"PricingHero_link__haBSv"};